module.exports = __webpack_public_path__ + "img/1.2c48deec.png";